import { userContext } from '../userManager';

export const apiNotificationDelete = notificationId =>
  userContext.apiCall({
    url: `/notifications/${notificationId}`,
    method: 'DELETE',
    noResBody: true,
  });
